import { router } from '@inertiajs/react'
import RecordActions from '@/frontend/features/Fde/RecordActions'
import FdeRecordStatus from '@/frontend/features/Fde/FdeRecordStatus'
import { elementImageUrl, elementSubtitle } from '@/frontend/features/Fde/ontologyProperties'
import { fdeRoutes } from '@/frontend/features/Fde/routes'
import type { FdeCopy, ModelElement } from '@/frontend/features/Fde/types'

interface Props {
  element: ModelElement
  projectId: string
  copy: FdeCopy
  canManage: boolean
  onOpen: () => void
  onEdit: () => void
}

export default function ElementListRow({ element, projectId, copy, canManage, onOpen, onEdit }: Props) {
  function remove() {
    if (window.confirm(copy.common.confirm_delete)) router.delete(`${fdeRoutes.objects}/${element.id}?project_id=${projectId}`, { preserveScroll: true })
  }

  function confirm() {
    router.patch(`${fdeRoutes.objects}/${element.id}?project_id=${projectId}`, { element: { status: 'confirmado' } }, { preserveScroll: true })
  }

  const imageUrl = elementImageUrl(element)
  const subtitle = elementSubtitle(element)
  return <article className="group flex min-h-14 items-center gap-3 px-3 py-2 hover:bg-muted/25">
    <button type="button" onClick={onOpen} className="flex min-w-0 flex-1 items-center gap-3 text-left" aria-label={`${copy.workspace.open_in_map}: ${element.name}`}>
      <span className="flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-border bg-muted text-[10px] font-semibold text-muted-foreground">
        {imageUrl ? <img src={imageUrl} alt="" className="size-full object-cover" /> : element.name.slice(0, 1).toLocaleUpperCase()}
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2">
          <strong className="truncate text-xs font-medium text-foreground">{element.name}</strong>
          <FdeRecordStatus status={element.status} proposedLabel={copy.workspace.proposed} confirmedLabel={copy.workspace.confirmed_status} />
        </span>
        <span className="mt-0.5 block truncate text-[10px] text-muted-foreground">{subtitle || element.description || copy.workspace.inspector_no_description}</span>
        {element.aliases.length > 0 && <span className="mt-0.5 block truncate text-[9px] text-muted-foreground/80">{element.aliases.join(' · ')}</span>}
      </span>
    </button>
    {canManage && <RecordActions proposed={element.status === 'proposto'} copy={copy} onEdit={onEdit} onConfirm={confirm} onDelete={remove} />}
  </article>
}
